import produce from 'immer';

// TYPES
import { Types, consultaSegundaViaReabilitacao } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: consultaSegundaViaReabilitacao = {
	status: 0,
	data: null,
};

export default function consultaSegundaViaReabilitacaoReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultaSegundaViaReabilitacao {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_SEGUNDA_VIA_REABILITACAO: {
				draft.status = 100;
				break;
			}

			case Types.CONSULTA_SEGUNDA_VIA_REABILITACAO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTA_SEGUNDA_VIA_REABILITACAO_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTA_SEGUNDA_VIA_REABILITACAO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
